module.exports = __webpack_public_path__ + "img/1.16f30eba.jpg";